// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//
export const prepareSiteMessageWithLink = (messageText: any, linkText: any, linkValue: any, argument: any) => {
    return messageText?.toString()?.replace(argument, `<a href="${linkValue}">${linkText.toString()}</a>`);
};

export const handleSiteMessageLinkClick = (e: any, callback: any) => {
    e.preventDefault();

    let el = e.target;

    while (el && el !== e.currentTarget && el.tagName !== "A") {
        el = el.parentNode;
    }

    if (el && el.tagName === "A") {
        callback && callback();
    }
};

export const doScroll = (scrollToTop = false) => {
    setTimeout(() => {
        const selector = document.querySelector("[aria-invalid='true']");

        if (selector) {
            selector.scrollIntoView({
                behavior: "smooth",
                block: "center",
            });

            return;
        }

        if (scrollToTop) {
            window.scrollTo(0, 0);
            return;
        }

        doScroll(scrollToTop);
    }, 500);
};

export const isProductInActive = (product: any) => {
    return (
        (product?.hasOwnProperty("isActive") && !product.isActive) ||
        (product?.hasOwnProperty("isActiveProduct") && !(product as any).isActiveProduct)
    );
};

export const isMobileWidth = () => window.outerWidth < 768;
